
export const REQUEST_ADD_TAG = 'REQUEST_ADD_TAG';
export const ADD_TAG_REQUEST_RECEIVED = 'ADD_TAG_REQUEST_RECEIVED'; 
export const REQUEST_GET_TAGS_LIST = 'REQUEST_GET_TAGS_LIST'; 
export const TAGS_LIST_RECEIVED = 'TAGS_LIST_RECEIVED'; 
